import { useMutation, useQueryClient } from '@tanstack/react-query';
import useGlynt from '../useGlynt';
import { IRQCallbacks } from '../../../types/my-types';
import { VendorType } from '../../../types/vendor-types';

interface UpdateVendorData {
  name?: string;
  abbreviated?: string;
  vendor_type?: VendorType;
}

const useUpdateVendor = (callbacks?: IRQCallbacks) => {
  const glynt = useGlynt();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ id, data }: { id: number; data: UpdateVendorData }) => {
      return (await glynt).vendor.updateVendor(id, data);
    },

    ...callbacks,

    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: ['vendors']
      });
    }
  });
};

export default useUpdateVendor;
